/**
 * Created by johnathansaunders on 12/9/17.
 */
import React from 'react';
import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';


export default class AppBarExampleIcon extends React.Component{


    constructor(props) {
        super(props);
        this.state = {open: false};
    }

    handleToggle = () => this.setState({open: !this.state.open});

    /**
     * A simple example of `AppBar` with an icon on the right.
     * By default, the left icon is a navigation-menu.
     */
    render()
    {


        return (
            <div>
                <AppBar
                    title="Now Playing"

                    iconClassNameRight="muidocs-icon-navigation-expand-more"
                    onLeftIconButtonClick={()=>this.handleToggle()}

                />
                <div>

                    <Drawer
                        docked={false}
                        disableSwipeToOpen={false}
                        width ={200}
                        swipeAreaWidth={60}
                        open={this.state.open}
                        onRequestChange={(open) => this.setState({open})}>
                        <MenuItem>Featured Artists</MenuItem>
                        <MenuItem>Local Artists</MenuItem>
                    </Drawer>
                </div>
            </div>



        );
    }
}


// WEBPACK FOOTER //
// ./src/AppBarExampleIcon.js